import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const EmployeeHeader = () => {
 const navigate = useNavigate();
 const location = useLocation();

 const tabs = ["Team Overview", "Performance", "Alerts"];
 const [activeTab, setActiveTab] = useState("Team Overview");

 const handleAddEmployee = () => {
 navigate("/users?mode=add-employee");
 };

 useEffect(() => {
 if (location.pathname.includes("employee-crm")) setActiveTab("Team Overview");
 else if (location.pathname.includes("employee-performance")) setActiveTab("Performance");
 else if (location.pathname.includes("employee-alerts")) setActiveTab("Alerts");
 }, [location.pathname]);

 const handleTabClick = (opt) => {
 setActiveTab(opt);
 if (opt === "Team Overview") navigate("/employee-crm");
 if (opt === "Performance") navigate("/employee-performance");
 if (opt === "Alerts") navigate("/employee-alerts");
 };

 const containerRef = useRef(null);
 const [thumbLeft, setThumbLeft] = useState(0);
 const [thumbWidth, setThumbWidth] = useState(0);

 const recalcSlider = () => {
 const index = tabs.indexOf(activeTab);
 const container = containerRef.current;
 if (!container) return;
 const segmentWidth = container.offsetWidth / tabs.length;
 setThumbLeft(index * segmentWidth);
 setThumbWidth(segmentWidth);
 };

 useEffect(() => {
 recalcSlider();
 }, [activeTab]);

 useEffect(() => {
 window.addEventListener("resize", recalcSlider);
 return () => window.removeEventListener("resize", recalcSlider);
 }, []);

 return (
 <div style={{ width: "100%", marginBottom: "1.5rem" }}>
 
 {/* TOP SECTION */}
 <div className="d-flex flex-column flex-md-row justify-content-between align-items-start gap-3">
 <div>
 <h2 style={{ fontWeight: 600, fontSize: "clamp(18px, 3vw, 24px)", marginBottom: "2px" }}>
 Employee CRM
 </h2>
 <div style={{ fontSize: "13px", color: "#6c757d" }}>
 Workforce management, task assignments & performance tracking.
 </div>
 </div>

 <div className="d-flex flex-wrap gap-2">
 <button
 className="btn btn-light btn-sm"
 style={{
 border: "1px solid #dce1e7",
 padding: "6px 14px",
 fontSize: "13px",
 fontWeight: 500,
 whiteSpace: "nowrap"
 }}
 >
 Auto-Assign
 </button>

 <button
 className="btn btn-primary btn-sm"
 style={{
 padding: "6px 14px",
 fontSize: "13px",
 fontWeight: 500,
 whiteSpace: "nowrap"
 }}
 onClick={handleAddEmployee}
 >
 + Add Employee
 </button>
 </div>
 </div>

 {/* TAB SLIDER */}
 <div
 ref={containerRef}
 style={{
 display: "flex",
 position: "relative",
 background: "#f6f7fa",
 marginTop: "16px",
 padding: "4px",
 border: "1px solid #e4e8ef",
 overflow: "hidden",
 height: "36px",
 cursor: "pointer",
 width: "100%",
 maxWidth: "500px"
 }}
 >
 <div
 style={{
 position: "absolute",
 top: "4px",
 bottom: "4px",
 left: thumbLeft,
 width: thumbWidth,
 background: "#ffffff",
 boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
 transition: "left .25s, width .25s"
 }}
 />

 {tabs.map((opt) => (
 <div
 key={opt}
 onClick={() => handleTabClick(opt)}
 style={{
 flex: 1,
 textAlign: "center",
 fontSize: "13px",
 fontWeight: 600,
 zIndex: 2,
 display: "flex",
 alignItems: "center",
 justifyContent: "center",
 gap: "4px",
 color: activeTab === opt ? "#000" : "#6c757d",
 transition: "color .25s"
 }}
 >
 {opt}
 </div>
 ))}
 </div>
 </div>
 );
};

export default EmployeeHeader;
